import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintReport } from '.';

/**
 * @component {kat-blueprint-report-context} KatBlueprintReportContext Component used to place and filter components within the context section.
 * @slot default Blueprint content for context section.
 */
@register(KatBlueprintReport.slotMapping.context.name)
export class KatBlueprintReportContext extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintReport.slotMapping.context.name,
      KatBlueprintReport.slotMapping.context.allowed
    );
  }
}
